import { useContext } from 'react';

import { LookerEnvContext } from '@/providers/looker-env';

export function useLookerEnv() {
  return useContext(LookerEnvContext);
}
